import React, { useEffect, useState } from "react";
import classes from "./Newitemproducts.module.css";
import HeaderNav from "../../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../../Components/Footer/Footer";
import { useLocation } from "react-router-dom";
import { Trash2, Upload } from "lucide-react";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import { BASE_URL } from "../../../Components/API/Api";
import * as XLSX from 'xlsx';

const NewPayables = () => {
  const [type, setType] = useState("products");
  const [productOptions, setProductOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [unitDiscount, setUnitDiscount] = useState("");
  const [unitOfMeasurement, setUnitOfMeasurement] = useState("");
  const [reOrderLevel, setReOrderLevel] = useState("");
  const [description, setDescription] = useState("");
  const [services, setServices] = useState([]);
  const [taxOptions, setTaxOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stockClassifications, setStockClassifications] = useState([]);
  const [name, setName] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [selectedStockClassificationId, setSelectedStockClassificationId] = useState("");
  const [selectedStockCategoryId, setSelectedStockCategoryId] = useState("");
  const [stockClassification, setStockClassification] = useState("");
  const [stockCategory, setStockCategory] = useState("");
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);



  const [invoiceItems, setInvoiceItems] = useState([
    {
      ledger: '',
      description: '',
      qty: 1,
      price: 0,
      discount: 0,
      vatRate: 'Premium',
      vat: 0,
      total: 0,
    }
  ]);
  const [accounts, setAccounts] = useState([]);
  const [selectedIncomeGL, setSelectedIncomeGL] = useState(null);
  const [selectedIncomeL, setSelectedIncomeL] = useState(null);
  const [selectedReceivablesGL, setSelectedReceivablesGL] = useState(null);
  const [loading, setLoading] = useState(true);
  const [stockCategories, setStockCategories] = useState([]);
  const [productService, setProductService] = useState("");
  const [shortName, setShortName] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [bulkStockClassification, setBulkStockClassification] = useState("");
  const [bulkStockCategory, setBulkStockCategory] = useState("");

  const token = localStorage.getItem("authToken");
  const handleCreateStock = async () => {
    setIsSubmitting(true);

    try {
      const payload = {
        name: productService,
        short_name: shortName,
        description: description,
        unit_price: unitPrice,
        quantity: invoiceItems[0]?.qty || 0,
        unit_discount: unitDiscount,
        stock_classification: stockClassification,
        stock_category: stockCategory,
        unit_of_measurement: unitOfMeasurement,
        re_order_level: reOrderLevel
      };


      const response = await axios.post(
        `${BASE_URL}/v1/create_stock`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "Stock created successfully!",
        }).then(() => {
          window.location.reload();
        });


      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: JSON.stringify(response.data.message),
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: error.message,
      });
    } finally {
      setIsSubmitting(false); // 🔹 Hide spinner & re-enable button
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/v1/download_stock_template`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          responseType: 'blob', // Important for file downloads
        }
      );

      // Create a blob URL from the response data
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = 'stock_template.xlsx'; // Default filename

      // Append to DOM, click, and cleanup
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Template Downloaded!",
        text: "Stock template has been downloaded successfully.",
      });
    } catch (error) {
      console.error("Error downloading template:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Failed to download the template. Please try again.",
      });
    }
  };

  const showExpectedFormat = () => {
    Swal.fire({
      icon: "info",
      title: "Expected Excel Format",
      html: `
         <div style="text-align: left;">
           <p><strong>Your Excel file should have these headers in the first row:</strong></p>
           <ul style="margin: 1rem 0; padding-left: 1rem;">
             <li><strong>NAME</strong> - Product or service name (required)</li>
             <li><strong>SHORT NAME</strong> - Short name or code</li>
             <li><strong>DESCRIPTION</strong> - Product description</li>
             <li><strong>UNIT PRICE</strong> - Unit price</li>
             <li><strong>QUANTITY</strong> - Initial quantity</li>
             <li><strong>UNIT DISCOUNT</strong> - Discount amount</li>
             <li><strong>UNIT OF MEASUREMENT</strong> - Unit of measurement (e.g., kg, pcs)</li>
             <li><strong>RE-ORDER LEVEL</strong> - Reorder level</li>
             <li><strong>STOCK ID</strong> - Stock identifier (optional)</li>
           </ul>
           <p><strong>Note:</strong> At least one of NAME, DESCRIPTION, or SHORT NAME must have data.</p>
           <p><strong>Example:</strong></p>
           <div style="background: #f5f5f5; padding: 0.5rem; border-radius: 4px; font-family: monospace; font-size: 12px;">
             NAME | SHORT NAME | DESCRIPTION | QUANTITY | UNIT PRICE<br/>
             Laptop Dell | LAP001 | Dell Laptop | 10 | 500000
           </div>
           <p><strong>Important:</strong> Stock Classification and Category will be set from the dropdowns above.</p>
         </div>
       `,
      confirmButtonText: "Got it!",
      width: "600px"
    });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'text/csv' // .csv
      ];

      if (!validTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Invalid File Type",
          text: "Please upload an Excel file (.xlsx, .xls) or CSV file.",
        });
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "Please upload a file smaller than 5MB.",
        });
        return;
      }

      setUploadedFile(file);
      Swal.fire({
        icon: "success",
        title: "File Selected Successfully!",
        text: `${file.name} has been selected. Please choose stock classification and category, then click "Process & Upload".`,
      });
    }
  };

  const processExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          // Convert to JSON with header row
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          console.log("Raw Excel data:", jsonData);

          if (jsonData.length < 2) {
            reject(new Error("Excel file must have at least a header row and one data row"));
            return;
          }

          // Extract headers and data
          const headers = jsonData[0];
          const rows = jsonData.slice(1);

          // More flexible header mapping with common variations
          const headerMapping = {
            // Product/Service variations
            'Product/Service': 'name',
            'Product/Service Name': 'name',
            'Product': 'name',
            'Service': 'name',
            'Name': 'name',
            'Product Name': 'name',
            'Service Name': 'name',
            'NAME': 'name',

            // Short Name variations
            'Short Name': 'short_name',
            'ShortName': 'short_name',
            'Short': 'short_name',
            'Code': 'short_name',
            'SKU': 'short_name',
            'SHORT NAME': 'short_name',

            // Description variations
            'Description': 'description',
            'Desc': 'description',
            'Details': 'description',
            'Notes': 'description',
            'DESCRIPTION': 'description',

            // Stock Classification variations
            'Stock Classification': 'stock_classification',
            'Classification': 'stock_classification',
            'Class': 'stock_classification',
            'Type': 'stock_classification',
            'STOCK CLASSIFICATION': 'stock_classification',

            // Stock Category variations
            'Stock Category': 'stock_category',
            'Category': 'stock_category',
            'Cat': 'stock_category',
            'Group': 'stock_category',
            'STOCK CATEGORY': 'stock_category',

            // Quantity variations
            'Quantity': 'quantity',
            'Qty': 'quantity',
            'Amount': 'quantity',
            'Count': 'quantity',
            'QUANTITY': 'quantity',

            // Price/Rate variations
            'Price/Rate': 'unit_price',
            'Price': 'unit_price',
            'Rate': 'unit_price',
            'Unit Price': 'unit_price',
            'Cost': 'unit_price',
            'UNIT PRICE': 'unit_price',

            // Discount variations
            'Discount': 'unit_discount',
            'Disc': 'unit_discount',
            'Discount %': 'unit_discount',
            'Discount Amount': 'unit_discount',
            'UNIT DISCOUNT': 'unit_discount',

            // Unit variations
            'Unit': 'unit_of_measurement',
            'Unit of Measurement': 'unit_of_measurement',
            'UOM': 'unit_of_measurement',
            'Measurement': 'unit_of_measurement',
            'UNIT OF MEASUREMENT': 'unit_of_measurement',

            // Re-order Level variations
            'Re-order Level': 're_order_level',
            'Reorder Level': 're_order_level',
            'Min Level': 're_order_level',
            'Minimum': 're_order_level',
            'RE-ORDER LEVEL': 're_order_level',

            // Additional variations for your specific format
            'STOCK ID': 'stock_id'
          };

          console.log("Headers found:", headers);
          console.log("Number of data rows:", rows.length);

          // Debug: Check which headers are being mapped
          headers.forEach((header, index) => {
            if (header && header.trim() !== '') {
              const mappedField = headerMapping[header.trim()];
              console.log(`Header "${header}" -> maps to: ${mappedField || 'UNMAPPED'}`);
            }
          });

          // Process each row
          const processedData = rows.map((row, index) => {
            const item = {};

            headers.forEach((header, colIndex) => {
              if (header && header.trim() !== '') { // Skip empty headers
                const mappedField = headerMapping[header.trim()];
                if (mappedField && row[colIndex] !== undefined && row[colIndex] !== null && row[colIndex] !== '') {
                  item[mappedField] = row[colIndex];
                }
              }
            });

            // Set default values for required fields
            if (!item.quantity) item.quantity = 0;
            if (!item.unit_price) item.unit_price = 0;
            if (!item.unit_discount) item.unit_discount = 0;
            if (!item.re_order_level) item.re_order_level = 0;

            // Log each processed item for debugging
            console.log(`Row ${index + 1}:`, item);

            return item;
          }).filter(item => {
            // More flexible filtering - check if item has at least a name or description
            const hasValidData = item.name || item.description || item.short_name;
            if (!hasValidData) {
              console.log(`Filtered out row:`, item);
            }
            return hasValidData;
          });

          console.log("Final processed data:", processedData);
          console.log("Number of valid items:", processedData.length);

          if (processedData.length === 0) {
            reject(new Error(`No valid data found. Headers: ${headers.join(', ')}. Please check your Excel format.`));
            return;
          }

          resolve(processedData);
        } catch (error) {
          console.error("Error in processExcelFile:", error);
          reject(error);
        }
      };

      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const clearUploadedFile = () => {
    setUploadedFile(null);
    setBulkStockClassification("");
    setBulkStockCategory("");
    setIsUploading(false);
  };

  const handleUploadProducts = async () => {
    if (!uploadedFile) {
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please select a file to upload first.",
      });
      return;
    }

    // Validate that classification and category are selected
    if (!bulkStockClassification) {
      Swal.fire({
        icon: "warning",
        title: "Stock Classification Required",
        text: "Please select a stock classification before uploading.",
      });
      return;
    }

    if (!bulkStockCategory) {
      Swal.fire({
        icon: "warning",
        title: "Stock Category Required",
        text: "Please select a stock category before uploading.",
      });
      return;
    }

    setIsUploading(true);

    try {
      // Show confirmation dialog
      const result = await Swal.fire({
        icon: "question",
        title: "Confirm Upload",
        html: `
           <p>Ready to upload Excel file <strong>${uploadedFile.name}</strong> with:</p>
           <ul style="text-align: left; margin: 1rem 0;">
             <li><strong>Classification:</strong> ${stockClassifications.find(c => c.id === bulkStockClassification)?.name || bulkStockClassification}</li>
             <li><strong>Category:</strong> ${stockCategories.find(c => c.id === bulkStockCategory)?.name || bulkStockCategory}</li>
           </ul>
           <p>The backend will process the Excel file and create the products.</p>
           <p>Do you want to proceed?</p>
         `,
        showCancelButton: true,
        confirmButtonText: "Yes, Upload",
        cancelButtonText: "Cancel",
      });

      if (!result.isConfirmed) {
        return;
      }

      // Upload the file directly to the backend
      try {
        const formData = new FormData();
        formData.append('file', uploadedFile);
        formData.append('stock_classification', bulkStockClassification);
        formData.append('stock_category', bulkStockCategory);

        const response = await axios.post(
          `${BASE_URL}/v1/upload_stocks`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        if (response.data.status) {
          // Show success message
          Swal.fire({
            icon: "success",
            title: "Upload Complete!",
            text: `Successfully uploaded Excel file. The backend is processing your products.`,
          });
        } else {
          // Show error message from API
          Swal.fire({
            icon: "error",
            title: "Upload Failed",
            text: response.data.message || "Failed to upload products.",
          });
        }
      } catch (error) {
        console.error("Error uploading stocks:", error);
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: error.response?.data?.message || error.message || "Failed to upload products.",
        });
      }

      // Reset file and selections
      setUploadedFile(null);
      setBulkStockClassification("");
      setBulkStockCategory("");

    } catch (error) {
      console.error("Error processing file:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: `Error processing file: ${error.message}`,
      });
    } finally {
      setIsUploading(false);
    }
  };

  useEffect(() => {
    const fetchStockClassifications = async () => {
      try {
        const token = localStorage.getItem("authToken"); // ✅ get token here
        const res = await axios.get(
          `${BASE_URL}/v1/fetch_stock_classification`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.status && Array.isArray(res.data.data)) {
          setStockClassifications(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching stock classifications:", err);
      }
    };

    fetchStockClassifications();
  }, []);
useEffect(() => {
  const fetchInvoices = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${BASE_URL}/'[v1/fetch-invoice-items`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status && Array.isArray(res.data.data)) {
        const formatted = res.data.data.map((inv) => ({
          value: inv.invoice_number, // we need this for step 2
          label: inv.invoice_number,
        }));
        setInvoiceOptions(formatted);
      }
    } catch (err) {
      console.error("Error fetching invoices:", err);
    }
  };

  fetchInvoices();
}, []);


  useEffect(() => {

    const token = localStorage.getItem("authToken");
    axios.get(`${BASE_URL}/v1/stock_category`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })

      .then((res) => {
        if (res.data.status) {
          setStockCategories(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching stock categories:", err);
      });
  }, []);

  const handleAddRow = () => {
    setInvoiceItems(prev => [
      ...prev,
      {
        ledger: '',
        description: '',
        qty: 1,
        price: 0,
        discount: 0,
        vatRate: 'Premium',
        vat: 0,
        total: 0,
      }
    ]);
  };

  const handleDeleteRow = (index) => {
    const newItems = [...invoiceItems];
    newItems.splice(index, 1);
    setInvoiceItems(newItems);
  };

  


  const location = useLocation();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  // const fetchProducts = async () => {
  // Replace with your API call
  //   setProducts([
  //     { name: "Product A", price: 100 },
  //     { name: "Product B", price: 200 },
  //   ]);
  // };
  // const fetchServices = async () => {
  // Replace with your API call
  //   setServices([
  //     { name: "Service A", price: 150 },
  //     { name: "Service B", price: 250 },
  //   ]);
  // };

  // Fetch data when type changes
  // React.useEffect(() => {
  //   if (type === "products") fetchProducts();
  //   else fetchServices();
  // }, [type]);

  // Fetch currencies for the Currency select




  const handleChange = (index, field, value) => {
    const updatedItems = [...invoiceItems];
    let item = { ...updatedItems[index] };

    if (field === 'vatRate') {
      // If value is an object from react-select, extract id and rate
    } else if (field === 'qty') {
      item.qty = Math.max(1, Number(value) || 1);
    } else {
      item[field] = value;
    }


    // Find the selected tax rate if vatRate is set
    let taxRate = 0.075; // default 7.5%
    if (item.vatRateValue) {
      taxRate = parseFloat(item.vatRateValue) / 100;
    } else if (item.vatRate) {
      const selectedTax = taxOptions.find(tax => tax.value === item.vatRate);
      if (selectedTax && selectedTax.rate) {
        taxRate = parseFloat(selectedTax.rate) / 100;
      }
    }

    const baseTotal = item.qty * item.price;
    const discount = item.discount || 0;
    const vatAmount = (baseTotal - discount) * taxRate;

    item.vat = vatAmount;
    item.total = baseTotal - discount + vatAmount;

    updatedItems[index] = item;
    setInvoiceItems(updatedItems);
  };



  useEffect(() => {
    const fetchAccounts = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const res = await axios.get(
          "https://api-sme.promixaccounting.com/api/v1/account",
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        const dataArray = Array.isArray(res.data?.data) ? res.data.data : [];

        console.log("Fetched Accounts:", dataArray.length);
        setAccounts(dataArray);
      } catch (error) {
        console.error("Error fetching accounts:", error);
        setAccounts([]);
      }
    };

    fetchAccounts();
  }, []);
  const receivableAccounts = accounts
    .filter(acc => acc.subcategory?.description === "Accounts Receivables")
    .map(acc => ({
      value: acc.id,
      label: acc.gl_name
    }));
  const incomeAccounts = accounts
    .filter(acc => acc.class?.description === "Income")
    .map(acc => ({
      value: acc.id,
      label: acc.gl_name
    }));

  console.log("Receivable Accounts for Select:", receivableAccounts);
  console.log("Income Accounts for Select:", incomeAccounts);

  useEffect(() => {
    if (!invoiceDate || !dueDate) return; // Wait until both dates are picked

    const sendDatesToAccountAPI = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const res = await axios.get(
          "https://api-sme.promixaccounting.com/api/v1/account",
          {
            params: {
              manufacted_date: invoiceDate,
              expiry_date: dueDate
            },
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json"
            }
          }
        );

        console.log("Account API response with dates:", res.data);
      } catch (error) {
        console.error("Error calling account API with dates:", error);
      }
    };

    sendDatesToAccountAPI();
  }, [invoiceDate, dueDate]);

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>New Supplier Payable</h2>
          <h1 className={classes.Titles}>Manage your Supplier Payables.</h1>
        </header>

        <form className={classes.form}>
          <div className={classes.bankfield} >

            <div className={classes.group2}>
              <label>Description</label>
              <input
                placeholder="Description"
                options={incomeAccounts}
                value={selectedIncomeL}
                onChange={setSelectedIncomeL}
              />
            </div>
            <div className={classes.group2}>
              <label>Cheque/Teller</label>
              <input
                placeholder="Enter Cheque/Teller Number"
                options={incomeAccounts}
                value={selectedIncomeL}
                onChange={setSelectedIncomeL}
              />
            </div>
            <div className={classes.group2}>
              <label>Total Amount</label>
              <input
                placeholder="Description"
                options={incomeAccounts}
                value={selectedIncomeL}
                onChange={setSelectedIncomeL}
              />
            </div>
            <div className={classes.group1}>
              <label>Transaction Date</label>
              <input
                type="date"
                value={invoiceDate}
                onChange={e => setInvoiceDate(e.target.value)}
                required
              />
            </div>
            {/* <div className={classes.group1}>
              <label>Expired Date</label>
              <input
                type="date"
                value={dueDate}
                onChange={e => setDueDate(e.target.value)}
                required
              />
            </div> */}

            <div className={classes.group2}>
              <label>Outstanding</label>
              <input
                placeholder="0.00"
                options={incomeAccounts}
                value={selectedIncomeL}
                onChange={setSelectedIncomeL}
              />
            </div>

            <div className={classes.group}>
              <label>Invoice Number</label>
              <Select
                placeholder="Select Invoice"
                options={invoiceOptions}
                value={selectedInvoice}
                onChange={setSelectedInvoice}
                isClearable
              />
            </div>
            <div className={classes.bankfieldd} >



              <div className={classes.group2}>
                <label>Payment Mode</label>
                <Select
                  placeholder="Payment mode"
                  options={incomeAccounts}
                  value={selectedIncomeL}
                  onChange={setSelectedIncomeL}
                />
              </div>
              <div className={classes.group2}>
                <label>Bank</label>
                <Select
                  placeholder="Select Bank"
                  options={incomeAccounts}
                  value={selectedIncomeL}
                  onChange={setSelectedIncomeL}
                />
              </div>
            </div>
          </div>



        </form>
        <div className={classes.invoicecont}>
          <div className={classes.tabcontaineractionbtn}>
            <div style={{ marginBottom: "1rem" }}>
              <button
                type="button"
                className={type === "products" ? classes.activeTab : classes.inactiveTab}
                onClick={() => setType("products")}
              >
                Products
              </button>
              {/* <button
                type="button"
                className={type === "services" ? classes.activeTab : classes.inactiveTab}
                onClick={() => setType("services")}
              >
                Services
              </button> */}
            </div>

            {/* <div style={{ marginBottom: "1rem" }}>
              <button
                type="button"
                className={classes.activeTab}
                onClick={() => document.getElementById('fileInput').click()}
              >
                <Upload size={16} style={{ marginRight: '8px' }} />
                Upload Products
              </button>
                             <button
                 type="button"
                 className={classes.inactiveTab}
                 onClick={handleDownloadTemplate}
               >
                 Download Template
               </button> */}



            {/* File upload section */}
            {/* {uploadedFile && (
                 <div style={{
                   marginBottom: "1rem",
                   padding: "1rem",
                   border: "1px solid #ddd",
                   borderRadius: "8px",
                   backgroundColor: "#f9f9f9"
                 }}>
                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
                     <div>
                       <strong>Selected File:</strong> {uploadedFile.name}
                       <br />
                       <small>Size: {(uploadedFile.size / 1024 / 1024).toFixed(2)} MB</small>
                     </div>
                     <div style={{ display: "flex", gap: "0.5rem" }}>
                       <button
                         type="button"
                         className={classes.inactiveTab}
                         onClick={clearUploadedFile}
                         disabled={isUploading}
                         style={{ minWidth: "80px" }}
                       >
                         Clear
                       </button>
                     </div>
                   </div>

                   {/* Stock Classification and Category Selection */}
            {/* <div style={{ marginBottom: "1rem" }}>
                     <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
                       <div>
                         <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "bold" }}>
                           Stock Classification *
                         </label>
                         <select
                           value={bulkStockClassification}
                           onChange={(e) => setBulkStockClassification(e.target.value)}
                           style={{
                             width: "100%",
                             padding: "0.5rem",
                             border: "1px solid #ddd",
                             borderRadius: "4px",
                             fontSize: "14px"
                           }}
                           disabled={isUploading}
                         >
                           <option value="">Select Classification</option>
                           {stockClassifications.map((classification) => (
                             <option key={classification.id} value={classification.id}>
                               {classification.name}
                             </option>
                           ))}
                         </select>
                       </div>
                       
                       <div>
                         <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "bold" }}>
                           Stock Category *
                         </label>
                         <select
                           value={bulkStockCategory}
                           onChange={(e) => setBulkStockCategory(e.target.value)}
                           style={{
                             width: "100%",
                             padding: "0.5rem",
                             border: "1px solid #ddd",
                             borderRadius: "4px",
                             fontSize: "14px"
                           }}
                           disabled={isUploading}
                         >
                           <option value="">Select Category</option>
                           {stockCategories.map((category) => (
                             <option key={category.id} value={category.id}>
                               {category.name}
                             </option>
                           ))}
                         </select>
                       </div>
                     </div>
                     
                     <button
                       type="button"
                       className={classes.activeTab}
                       onClick={handleUploadProducts}
                       disabled={isUploading || !bulkStockClassification || !bulkStockCategory}
                       style={{ 
                         minWidth: "120px",
                         opacity: (!bulkStockClassification || !bulkStockCategory) ? 0.6 : 1
                       }}
                     >
                                               {isUploading ? (
                          <>
                            <Spinner animation="border" size="sm" /> Uploading...
                          </>
                        ) : (
                          "Upload Excel File"
                        )}
                     </button>
                   </div>

                                       {isUploading && (
                      <div style={{ marginTop: "1rem" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                          <Spinner animation="border" size="sm" />
                          <span>Uploading Excel file to backend...</span>
                        </div>
                      </div>
                    )}
                 </div>
               )} 
            </div>*/}
          </div>

          {/* Hidden file input */}
          <input
            id="fileInput"
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileUpload}
            style={{ display: 'none' }}
          />




          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th className={classes.productservice}>Item</th>
                {/* <th>Short name</th> */}
                {/* <th>Description</th> */}
                {/* <th>Stock Classification</th> */}

                <th>Total Amount</th>
                <th>Outstanding</th>
                <th>Amount to pay </th>
                {/* <th className={classes.priceRateCol}>Amount to pay*</th> */}
                <th>Subtotal</th>
                {/* <th>Unit (kg)</th> */}
                {/* <th>Re-order Level</th> */}
                <th>
                  <button
                    type="button"
                    className={classes.addRowBtn}
                    onClick={handleAddRow}
                  >
                    +
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {invoiceItems.length === 0 ? (
                <tr>
                  <td colSpan="11">
                    {type === "products" ? (
                      <div>
                        {products.length === 0 ? "Loading products..." : (
                          <ul>
                            {products.map((p, i) => (
                              <li key={i}>{p.name} - ₦{p.price}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ) : (
                      <div>
                        {services.length === 0 ? "Loading services..." : (
                          <ul>
                            {services.map((s, i) => (
                              <li key={i}>{s.name} - ₦{s.price}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ) : (
                invoiceItems.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={productService}
                        onChange={(e) => setProductService(e.target.value)}
                      // placeholder="Enter Product/Service"
                      />
                    </td>
                    {/* <td>
                      <input
                        type="text"
                        value={shortName}
                        onChange={(e) => setShortName(e.target.value)}
                      // placeholder="Enter Short Name"
                      />
                    </td> */}
                    {/* <td>
                      <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter description"
                      />
                    </td> */}
                    {/* <td>
                      <select
                        value={stockClassification}
                        onChange={(e) => setStockClassification(e.target.value)}
                      >
                        <option value="">Select Classification</option>
                        {stockClassifications.map((classification) => (
                          <option key={classification.id} value={classification.id}>
                            {classification.name}
                          </option>
                        ))}
                      </select>

                    </td> */}

                    {/* <td>
                      <select
                        value={item.stock_category_id || ""}
                        onChange={(e) => {
                          handleChange(index, "stock_category_id", e.target.value);
                          setStockCategory(e.target.value); // keep state in sync for API
                        }}
                      >
                        <option value="">Select Category</option>
                        {stockCategories.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                      <select
                        value={item.stock_category_id || ""}
                        onChange={(e) =>
                          handleChange(index, "stock_category_id", e.target.value)
                        }
                      >
                        <option value="">Select Category</option>
                        {stockCategories.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </td> */}
                    <td>
                      <input
                        type="number"
                        min={1}
                        value={item.qty}
                        onChange={(e) => handleChange(index, 'qty', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={unitPrice}
                        className={classes.inputField}
                        onChange={(e) => setUnitPrice(e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={unitDiscount}
                        className={classes.inputField2}
                        onChange={(e) => setUnitDiscount(e.target.value)}
                      />
                    </td>
                    {/* <td>

                      <input
                        type="text"
                        value={unitOfMeasurement}
                        onChanghttp://localhost:3000/transactions/newactione={(e) => setUnitOfMeasurement(e.target.value)}
                      />
                    </td> */}
                    <td>
                      <input
                        type="number"
                        value={reOrderLevel}
                        className={classes.reorderd}
                        onChange={(e) => setReOrderLevel(e.target.value)}
                      />
                    </td>
                    <td>
                      <Trash2
                        size={16}
                        onClick={() => handleDeleteRow(index)}
                        className={classes.deleteIcon}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>2</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - {invoiceItems.length} of {invoiceItems.length}</span>
            </div>
          </div>
        </div>
        <div className={classes.actionButtons}>
          <button className={classes.cancelButton}>Cancel</button>
          <button
            className={classes.saveButton}
            type="button"
            onClick={handleCreateStock}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <Spinner animation="border" size="sm" /> Creating...
              </>
            ) : (
              "Create Payable"
            )}
          </button>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewPayables;
